import { createTheme, Divider, Grid, IconButton, MuiThemeProvider } from '@material-ui/core';
import { Add, Delete as DeleteIcon } from '@material-ui/icons';
import MUIDataTable from 'mui-datatables';
import { useSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import SelectRackType from '../../components/Form/SelectRackType';
import TextField from '../../components/Form/TextField';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import getDefaultGridOptions from '../../utils/componentUtils';
import { useStyles } from './Style';
import { useAuth } from "../../hooks/auth";

interface containerType {
    label: string;
    value: string;
    rackTypeCode: string;
}

interface IFormInput {
    PackingTypeCode: containerType; 
    containerAmount: number;
    volumesAmount: number;
}

type props =  any;

const ContainerUnload: React.FC<props> = ({ control, name }) => {
    const refVasilhame = useRef<HTMLElement>(null)
    const classes = useStyles()
    const { t: tval } = useTranslation("Validation");
    const { t } = useTranslation("Mvm")
    const { t: _t } = useTranslation("General")
    const [initialFocus, setInitialFocus] = useState(false);
    const { enqueueSnackbar } = useSnackbar()
    const { fields, append, update, remove } = useFieldArray({ control, name: name });
    const { control: frmControl, setError, clearErrors, setValue: setVal } = useForm({}); 
    const { control: formControl, setError: setFormError, handleSubmit, setValue, getValues, reset } = useForm<any>(
    {
        defaultValues: { volumesAmount: 0, containerAmount: 0, PackingTypeCode: {} }
    })
    const { isPortoReal } = useAuth();
    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: '',
                }
            },
            MuiTableCell: {
                root: {
                    padding: 2,
                    paddingRight: 2,
                    paddingLeft: 2
                }
            },
            MuiTableHead:{
                root:{
                    height: '56px',
                    fontWeight: 'bold',
                    fontSize: 18
                }
            }
        }
    })

    const columns = [
        {
            name: 'PackingTypeCode',
            label: t("packing"),
            options: {
                customBodyRender: (value: any, tableMeta: any) => <span>{value.label}</span>
            }
        },
        {
            name: 'containerAmount',
            label: t("packingQuantity"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    width: '100px'
                  }),
                setCellProps: () => ({
                    align: "center",
                    width: '100px'
                }),
                // customBodyRender: (value: any, tableMeta: any) => (
                //     renderContainerAmount(value, tableMeta)
                // )
            }
        },
        {
            name: 'volumesAmount',
            label: t("volumesAmount"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    width: '100px'
                  }),
                setCellProps: () => ({
                    align: "center",
                    width: '100px'
                }),
                // customBodyRender: (value: any, tableMeta: any) => (
                //     renderVolumesAmount(value, tableMeta)
                // )
            }
        },
        {
            name: "PackingTypeCode",
            label: ' ',
            options: {
                setCellProps: () => ({
                    align: "right",
                    width: '100px'
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <IconButton aria-label="delete" onClick={() => remContainer(tableMeta.rowIndex)}>
                            <DeleteIcon color='error' fontSize='large'/>
                        </IconButton>
                    );
                }
            }
        },
    ]

    const remContainer = (index: any) => {
        remove(index);
    }

    const addContainer = async() => {
        var data = getValues();

        if(!await yupValidation(data)) 
            return false;
        
        let dados: any = fields;
        const reg = dados.find((item: IFormInput)  => item.PackingTypeCode.rackTypeCode == data.PackingTypeCode.rackTypeCode);
        
        if (reg){
            let lista = dados.map((item: any, index: any) => {
                
                if (item?.PackingTypeCode?.rackTypeCode == data.PackingTypeCode.rackTypeCode)
                {
                    item.containerAmount = Number(item.containerAmount) + Number(data.containerAmount);
                    item.volumesAmount = Number(item.volumesAmount) + Number(data.volumesAmount);
                    update(index, item);
                }
            })
        }else{
            append(data);
        }
        reset({volumesAmount: 0, containerAmount: 0, PackingTypeCode: ""});

    }

    const onSubmit = (data: any) => {  }
   
    
    const yupValidation = async (data: any) => {
        clearErrors();
        try {
            const schema = Yup.object().shape({
                PackingTypeCode: Yup.object().nullable().shape({ rackTypeCode: Yup.string().required('Tipo do Vasilhame é obrigatório') }),
                volumesAmount: Yup.number().required(tval("requiredField")).min(1, 'A Quatidade de Volumes deve ser maior que 0'),
                containerAmount: Yup.number().required(tval("requiredField")).min(1, 'A Quatidade de Vasilhames deve ser maior que 0')
            });
            
            await schema.validate(data, {
                 abortEarly: false
            });

            return true;
        }  catch (err) {
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    var campo:string = error.path ? error.path.split('.')[0] : '-----';
                    if (" volumesAmount  containerAmount PackingTypeCode".indexOf(campo.trim()) > -1) 
                        enqueueSnackbar(error.message, { variant: 'error' });
                })
            }

            return false;
        }
    }

    return (
        (isPortoReal() ? (
            <></>
        ) : 
        <>
            <form onSubmit={handleSubmit(onSubmit)} >   
                <Divider style={{ marginTop: '10px' }} />

                <PageTitle title={'Descarga de Vasilhames'} style={{marginLeft: 10}}/>
                <Grid container spacing={1}>
                    <Grid item xs={3}>
                        <SelectRackType 
                            label="Vasilhame"
                            name="PackingTypeCode"
                            control={formControl} 
                            style={{width: '100%'}}
                            multiple={false} 
                            inputRef={refVasilhame}/>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label={'Qtde. Vasilhames:'}
                            name="containerAmount"
                            type={"number"}
                            control={formControl}
                            className={classes.rootForm}
                            inputProps={{ maxLength: 4 }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label={'Qtde. Volumes:'}
                            name="volumesAmount"
                            type={"number"}
                            control={formControl}
                            className={classes.rootForm}
                            inputProps={{ maxLength: 4 }}
                            fullWidth
                        />
                    </Grid>
                    <Grid>
                        <ButtonUI
                            onClick={() =>{ addContainer(); refVasilhame?.current?.focus();}}
                            type="submit"
                            color="primary"
                            variant="contained"
                            style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: 15, marginLeft: '10px' }}>
                            <Add />
                        </ButtonUI>
                    </Grid>
                </Grid>
                <Grid style={{ marginTop: 20, width: "80%", marginLeft: 10, marginBottom: 10 }}>
                    <MuiThemeProvider theme={myTheme}>
                        <MUIDataTable
                            title=""
                            data={fields}
                            columns={columns}
                            options={{
                                ...getDefaultGridOptions(_t),
                                serverSide: true,
                                pagination: false,
                                sort: false,
                                selectToolbarPlacement: "none",
                                filter: false,
                                search: false,
                                download: false,
                                print: false,
                                viewColumns: false,
                                selectableRows: 'none',
                            }}
                        />
                    </MuiThemeProvider>
                </Grid>
                <Divider style={{ marginTop: 10, marginBottom: 10 }} />
            </form>
        </>)
    )
}
export default ContainerUnload;
